module.exports = __webpack_public_path__ + "assets/media/information_swallow_mix.113718d5.mp4";